'use client';
const IDENT = 'Avatar';
const defaultProps = {
    radius: 'round',
    size: 'xl1',
    withBorders: false,
    color: 'button.secondary',
    borderColor: 'emerald',
    insideBorderColor: 'background.content'
};

export { IDENT, defaultProps };
//# sourceMappingURL=Avatar.contract.js.map
